const TopSystems = {

    /**
     *
     * @returns {TopSystems}
     * @private
     */
    __construct: function () {
        this.init();
        return this;
    },

    resizeHandler: null,

    /**
     *
     */
    init: function () {
        console.log('The Top Systems corporate website was created by https://loungeroom.nl');
        this.slick();
        this.hoverMenu();
        this.jump();
        // this.clamp();
        this.scrollButton();
        this.faq();
        this.projectFilters();
        this.projectPDF();
        this.trainingFilters();
        this.eventFilters();
        this.showMore();
        TopSystems.resizeHandler = window.setTimeout(function () {
            TopSystems.fitHeights();
        }, 50)

        $(window).scroll(TopSystems.scrollWatcher);
        $(document).on('touchstart touchmove touchend', TopSystems.scrollWatcher);
        $(window).on('resize', function () {
            if (TopSystems.resizeHandler) {
                window.clearTimeout(TopSystems.resizeHandler);
            }
            TopSystems.resizeHandler = window.setTimeout(function () {
                TopSystems.fitHeights();
            }, 200)
        });

    },

    scrollOffset: 120,
    lastScrollTop: 0,
    scrollTimeout: null,
    scrollWatcher: function () {
        let st = $(window).scrollTop();
        let body = $("body");

        if (st > TopSystems.scrollOffset) {
            $('#back-to-top').fadeIn(200);
        } else {
            $('#back-to-top').fadeOut(200);
        }

        if (st > 0) {
            body.addClass('scrolled-down-start'); // we can start animations with this class
        } else {
            body.removeClass('scrolled-down-start');
        }

        if (st > 200) {
            body.addClass('has-scrolled'); // indicator we scrolled at least once
            body.addClass('scrolled-down'); // we can physically hide elements with this class
        } else {
            body.removeClass('scrolled-down');
        }

        if (st > TopSystems.lastScrollTop) {
            body.removeClass('scrolled-up');
        } else {
            body.addClass('scrolled-up');
        }

        window.setTimeout(function () {
            TopSystems.lastScrollTop = st;
        }, 200);
    },
    isMobile: false,
    isTablet: false,

    isMobileWidth: function () {
        return (window.matchMedia('(max-width: 767px)').matches);
    },

    isMobileAgent: function () {
        var check;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    isTabletAgent: function () {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    detectMobileDevice: function () {
        $("html").removeClass('is-mobile');
        $("html").removeClass('is-tablet');
        TopSystems.isMobile = false;
        TopSystems.isTablet = false;

        if (TopSystems.isMobileAgent()) {
            if (window.matchMedia('(max-device-width: 767px)').matches) {
                $("html").addClass('is-mobile');
                TopSystems.isMobile = true;
            }
        } else if (TopSystems.isTabletAgent()) {
            if (window.matchMedia('(max-device-width: 1280px)').matches) {
                $("html").addClass('is-mobile');
                $("html").addClass('is-tablet');
                TopSystems.isTablet = true;
            }
        }
    },


    fitHeights: function () {
        let cats = {};
        $('[data-equal-height]').height('').filter(function (i, o) {
            let selector = $(o).data('equal-height');
            if (cats[selector]) {
                return false;
            } else {
                cats[selector] = selector;
                return true;
            }
        });

        $.each(cats, function (i, cat) {
            let highest = 0;
            $('[data-equal-height="' + cat + '"]').each(function (si, so) {
                let thisHeight = $(so).height();
                if (thisHeight > highest) {
                    highest = thisHeight;
                }
            });

            if (highest > 0) {
                $('[data-equal-height="' + cat + '"]').height(Math.ceil(highest));
            }
        });


    },

    scrollButton: function () {
        $('#back-to-top').on('click', function () {
            $('body,html').stop().animate({
                scrollTop: 0
            }, 400);
            return false;
        });

    },

    hoverTimeout: null,

    hoverMenu: function () {
        // if not on mobile
        if (!$('.navbar-toggler').is(':visible')) {
            $(".dropdown").mouseenter(function () {
                if (TopSystems.hoverTimeout) {
                    window.clearTimeout(TopSystems.hoverTimeout);
                }
                var dropdownMenu = $(this).children(".dropdown-menu");
                if (dropdownMenu.is(":visible")) {
                    dropdownMenu.parent().addClass("open");
                    dropdownMenu.addClass("show");
                }
            });
            $(".dropdown").mouseleave(function () {
                TopSystems.hoverRemoveDelayed($(this));
            });
            $(".dropdown-menu").mouseenter(function () {
                if (TopSystems.hoverTimeout) {
                    window.clearTimeout(TopSystems.hoverTimeout);
                }
            });
        }
    },

    hoverRemoveDelayed: function ($element) {
        if (TopSystems.hoverTimeout) {
            window.clearTimeout(TopSystems.hoverTimeout);
            TopSystems.hoverTimeout = null;
        }
        if (!TopSystems.hoverTimeout) {
            TopSystems.hoverTimeout = window.setTimeout(function () {
                $element.closest(".dropdown").removeClass('open');
                $element.children(".dropdown-menu").removeClass("show");
            }, 500);
        }
    },

    // clamp: function () {
    //     $('.page__centered-block--content').each(function (i, o) {
    //         var collapsedHeight = 190;
    //
    //         new Readmore(o, {
    //             speed: 75,
    //             embedCSS: false,
    //             collapsedHeight: collapsedHeight,
    //             moreLink: $(o).data('more') ? '<a href="#">' + $(o).data('more') + '</a>' : false,
    //             lessLink: $(o).data('less') ? '<a href="#">' + $(o).data('less') + '</a>' : false,
    //             beforeToggle: function (trigger, element, expanded) {
    //                 if ($(o).closest('.clamp-holder').length === 1) {
    //                     $(o).closest('.clamp-holder').toggleClass('opening', !expanded);
    //                 } else {
    //                     $(o).toggleClass('opening', !expanded);
    //                 }
    //             },
    //             afterToggle: function (trigger, element, expanded) {
    //                 if ($(o).closest('.clamp-holder').length === 1) {
    //                     $(o).closest('.clamp-holder').toggleClass('opened', expanded);
    //                 } else {
    //                     $(o).toggleClass('opened', expanded);
    //                 }
    //                 // },
    //                 // blockProcessed: function (element, collapsible) {
    //                 //     if (!collapsible) {
    //                 //         $(element).css('height', '');
    //                 //     }
    //             }
    //         });
    //     })
    // },

    slick: function () {
        $('.simple-slider').each(function (i, slider) {
            var $slider = $(slider);
            var breakpoint768 = {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: false
                }
            };
            var breakpoint980 = {
                breakpoint: 980,
                settings: {
                    arrows: false,
                    dots: false
                }
            };
            var sliderOptions = {
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 10000
            };

            if ($(slider).data('disable-autoplay')) {
                sliderOptions.autoplay = false;
            }

            if ($(slider).data('browse') || $(slider).hasClass('arrows')) {
                sliderOptions.arrows = true;
            }

            if ($(slider).data('dots') || $(slider).hasClass('dots')) {
                sliderOptions.dots = true;
                breakpoint980.settings.dots = true;
            }

            if ($(slider).data('arrows-mobile')) {
                breakpoint768.settings.arrows = true;
                breakpoint980.settings.arrows = true;
            }

            if ($(slider).data('dots-mobile')) {
                breakpoint768.settings.dots = true;
            }

            if ($(slider).data('multiple')) {
                if (typeof $(slider).data('multiple') == 'number') {
                    sliderOptions.slidesToShow = parseInt($(slider).data('multiple'));
                    breakpoint768.settings.slidesToShow = 1;
                    breakpoint980.settings.slidesToShow = 1;
                } else {
                    sliderOptions.slidesToShow = 4;
                    breakpoint768.settings.slidesToShow = 1;
                    breakpoint980.settings.slidesToShow = 1;
                }
            }

            sliderOptions.responsive = [
                breakpoint768,
                breakpoint980
            ];

            $slider.on('afterChange', function (event, slick, currentSlide) {
                TopSystems.slideApplyCurrent(slider, currentSlide);
            });

            if ($(slider).data('nav-for')) {
                sliderOptions.asNavFor = $(slider).data('nav-for');
            }

            $(slider).slick(sliderOptions);

            TopSystems.slideApplyCurrent(slider, 0);

        });

        $('.slider__nav[data-nav-for] .nav-slide').on('click', function () {
            var $slider = $($(this).closest('.slider__nav').data('nav-for'));
            $slider.slick('slickGoTo', $(this).data('index') - 1);
        });

        $('.slider-navigation').on('click', '[data-slide]', function (e) {
            e.preventDefault();
            var $slider = $('#' + $(this).closest('.slider-navigation').data('slider'));
            $slider.slick('slickGoTo', $(this).data('slide'));
            TopSystems.scrollToElement($slider)
        });

        $(".slider-nav a.prev").on('click', function (e) {
            e.preventDefault();
            var element = $(this).closest('.slider__holder').find('.simple-slider').eq(0);
            element.slick('slickPrev');
        });
        $(".slider-nav a.next").on('click', function (e) {
            e.preventDefault();
            var element = $(this).closest('.slider__holder').find('.simple-slider').eq(0);
            element.slick('slickNext');
        });
    },

    scrollToElement: function ($element) {
        var scrollTop = $element.offset().top;
        if ($("body").css('padding-top')) {
            scrollTop = parseInt(scrollTop) - parseInt($("body").css('padding-top'));
        }
        TopSystems.jumpTo(scrollTop);
    },

    jumpTo: function (positionY) {
        $('html,body').stop().animate({scrollTop: positionY}, 300, 'swing');
    },

    jump: function () {
        $("body").on('click', 'a.jump, a[data-jump]', function (e) {
            e.preventDefault();
            var scrollID = $(this).data('jump') ? $(this).data('jump') : $(this).attr('href');
            if (scrollID === '#top') {
                TopSystems.jumpTo(0);
            } else if ($(scrollID).length === 1) {
                TopSystems.scrollToElement($(scrollID));
            }
        });
    },

    slideApplyCurrent: function (slickElement, currentSlide) {
        if (!currentSlide) {
            var currentSlide = $(slickElement).slick('slickCurrentSlide');
        }

        var $navigator = $('.slider-navigation[data-slider="' + $(slickElement).attr('id') + '"]');
        if ($navigator) {
            $navigator.find('a').removeClass('active');
            $navigator.find('a').eq(currentSlide).addClass('active');
        }
    },

    showMore: function () {
        $('a[data-more]').on('click', function (e) {
            e.preventDefault();
            if ($(this).data('collapse-parent')) {
                $(this).parent().slideUp(100);
            } else if ($(this).data('collapse')) {
                $($(this).data('collapse')).hide();
            }
            $($(this).data('more')).slideDown(250);
        });

        $('a[data-less]').on('click', function (e) {
            e.preventDefault();
            let self = this
            $($(this).data('less')).slideUp(100);
            if ($(self).data('expand-parent')) {
                $(self).parent().slideDown(250);
            } else if ($(self).data('expand')) {
                $($(self).data('expand')).slideDown(250);
            }
        });
    },

    faq: function () {
        $('[data-toggle]').on('click', function (e) {
            e.preventDefault();
            var self = $(this);
            var ref = self.data('toggle');

            // close others
            var holder = self.closest(self.data('container'));
            var parent = holder.parent();
            var others = parent.find('[data-toggle]').not('[data-toggle="' + ref + '"]');

            others.each(function (i, other) {
                let otherHolder = $(other).closest($(other).data('container'));
                otherHolder.removeClass('opening');
                $(otherHolder).find('[data-togglee]').slideUp(250, function () {
                    $(otherHolder).removeClass('opened');
                })
            });

            if (holder.hasClass('opened')) {
                holder.removeClass('opening');
                $('[data-togglee="' + ref + '"]').slideUp(250, function () {
                    holder.removeClass('opened');
                })
            } else {
                holder.addClass('opening');
                $('[data-togglee="' + ref + '"]').slideDown(250, function () {
                    holder.addClass('opened');
                })
            }
        })
    },

    projectFilters: function () {
        $('.project__filters').on('change', 'input[type="checkbox"]', function (e) {
            e.preventDefault();
            TopSystems.projectFiltersChanged()
        })
        $('.project__filters').find('form').on('reset', function (e) {
            window.setTimeout(function () {
                TopSystems.projectFiltersChanged()
            }, 100)
        })
    },

    projectFiltersChanged: function () {
        var results__container = $('.project__results');
        var projects = $('.project__results .single__project');
        var show = [];

        var checked = $('.project__filters input[type="checkbox"]:checked');

        if (checked.length === 0) {
            projects.show();
            $('[data-projects-found]').text(projects.length)
            $('[data-projects-word]').text(projects.length === 1 ? 'project' : 'projecten')
        } else {
            var marketsChecked = [];
            var marketsFound = [];
            var solutionsFound = [];
            var solutionsChecked = [];

            $('.project__filters input[type="checkbox"]:checked').each(function (index, checkbox) {
                var self = $(checkbox);
                var name = $(checkbox).prop('name');
                var group = 'solution';
                var value = self.prop('value');
                if (name.indexOf('Markets') === 0) {
                    group = 'sector';
                }

                if (group === 'solution') {
                    solutionsChecked = value
                } else {
                    marketsChecked = value
                }

                var selector = '[data-' + group + '-' + value + ']';
                if (projects.filter(selector).length > 0) {
                    projects.filter(selector).each(function (i, o) {
                        if (group === 'solution') {
                            solutionsFound.push($(o).data('id'));
                        } else {
                            marketsFound.push($(o).data('id'));
                        }
                    })
                }
            });

            if (solutionsChecked.length > 0 && marketsChecked.length > 0) {
                // we only show intersecting id's
                show = $(marketsFound).filter(solutionsFound).toArray()
            } else if (solutionsChecked.length > 0) {
                show = solutionsFound
            } else if (marketsChecked.length > 0) {
                show = marketsFound
            }

            show = show.filter(TopSystems.onlyUnique)

            projects.hide();
            $('[data-projects-found]').text(show.length)
            $('[data-projects-word]').text(show.length === 1 ? 'project' : 'projecten')

            if (show.length > 0) {
                $(show).each(function (index, id) {
                    projects.filter('[data-id="' + id + '"]').show()
                });
            }
        }
    },

    projectPDF: function () {
        $('a[data-toggle-pdf]').on('click', function (e) {
            e.preventDefault();
            $('.pdf__download_block').toggle();
            $('.project__details_block').toggle();
        });
    },

    trainingFilters: function () {
        $('.training__filters').on('change', 'input[type="checkbox"]', function (e) {
            e.preventDefault();
            TopSystems.trainingFiltersChanged()
        })
        $('.training__filters').find('form').on('reset', function (e) {
            window.setTimeout(function () {
                TopSystems.trainingFiltersChanged()
            }, 100)
        })
    },

    trainingFiltersChanged: function () {
        var trainings = $('.training__results .single__training');
        var show = [];
        var checked = $('.training__filters input[type="checkbox"]:checked');

        if (checked.length === 0) {
            trainings.show();
        } else {
            var marketsFound = [];

            $('.training__filters input[type="checkbox"]:checked').each(function (index, checkbox) {
                var self = $(checkbox);
                var value = self.prop('value');

                var selector = '[data-sector-' + value + ']';
                if (trainings.filter(selector).length > 0) {
                    trainings.filter(selector).each(function (i, o) {
                        marketsFound.push($(o).data('id'));
                    })
                }
            });

            show = marketsFound
            show = show.filter(TopSystems.onlyUnique)
            trainings.hide();

            if (show.length > 0) {
                $(show).each(function (index, id) {
                    trainings.filter('[data-id="' + id + '"]').show()
                });
            }
        }
    },

    eventFilters: function () {
        $('.event__filters').on('click', 'a', function (e) {
            e.preventDefault();
            TopSystems.eventFiltersChanged($(this))
        })
    },

    eventFiltersChanged: function ($current) {
        if (!$current.hasClass('active')) {
            $('.event__filters a').not($current).removeClass('active');
            $current.addClass('active');
        }

        var events = $('.event__results .single__event');
        if ($current.data('type') === 'all') {
            events.show();
        } else {
            events.hide();
            events.filter('[data-type="' + $current.data('type') + '"]').show()
        }
    },

    onlyUnique: function (value, index, self) {
        return self.indexOf(value) === index;
    }

};

module.exports = TopSystems.__construct();
